import React,{useState,useEffect} from 'react';
import {Api} from '../component/api';
import { Link,useNavigate } from 'react-router-dom';

const Search = ({ isOpen, toggleSearch }) => {
  const [data, setData] = useState({
    products:[]});
  const [SearchString, setSearchString] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); 

  async function fetchData(SearchString,nextPage=0) {
    if(!SearchString)
    {
        return;
    }
    setLoading(true);
    try {
        const response = await Api("productSearch",{s: SearchString});
        if(response.success==true){
            setData(response.psdata);
            //setData(response.psdata);
        }
    } catch (error) {
        console.error("API Error:", error);
    } 
    finally {
        setLoading(false); // پایان بارگذاری
    }
  }
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      navigate(`/search?s=${encodeURIComponent(SearchString)}`);
      toggleSearch();
    }
  };
  useEffect(() => {
      fetchData(SearchString);
  }, [SearchString]);

  useEffect(() => {
    if(isOpen==false)
    {
      setSearchString("");
    }
  }, [isOpen]);
  
    return (
      <>
      {isOpen && (<div className="cart-backdrop" onClick={toggleSearch}></div>)}
      <div className={`search-container ${isOpen ? 'open' : ''}`}>
        <div className="search-header d-flex justify-content-between align-items-center">
            <input 
              className='search-input' 
              type='text' 
              placeholder='جستجو محصولات...' 
              onChange={(e)=>setSearchString(e.target.value)}
              onKeyDown={handleKeyDown}
              value={SearchString}
            />
          <button className="btn-close" onClick={toggleSearch}></button>
        </div>
       
        {SearchString && (
        <div className='search-result'>
        {!loading? (
          <ul>
          {data.products.map((Product) => (
            <li><Link to={`/${Product.id_product}-${Product.link_rewrite}.html`}  onClick={() => toggleSearch()}>{Product.name}</Link></li>
          ))}
          </ul>):
          (
            <div class="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            </div>
          )
        }
        </div>
        )}
      </div>
      </>
    );
  };
  
  export default Search;